// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__bVzyd","label":"styles_label__pt2nR","icon":"styles_icon__D6VBo"};